import formatter from "../../../constants/currencyFormatter"

export default function RatesRow({ rate }) {
  const formatRateAmount = (amount) => {
    try {
      if (rate.name === 'Base Rate') {
        return `${amount}%`
      } else if (rate.name === 'Curtailment Fee') {
        let splitAmount = amount.split('/')
        return `$${splitAmount[0]}/$${splitAmount[1]}`
      } else {
        return formatter.format(amount)
      }
    } catch (error) {
      return amount
    }
  }


  return(
    <tr className='border-b-2 border-grey-700 rounded' key={rate.name}>
      <td className='p-2 text-center'>{rate.name}</td>
      <td className='p-2 text-center'>{formatRateAmount(rate.amount)}</td>
      <td className='py-2 px-3'>{rate.definition}</td>
    </tr>
  )
}